module.exports = __webpack_public_path__ + "img/geo-alt.c5a80b41.svg";